const getLegacyProductByType = (lineItems, type)=>{
    var ref;
    if (!type) {
        var ref1;
        return (ref1 = lineItems.find((lineItem)=>lineItem.isMainBundleLineItem
        )) === null || ref1 === void 0 ? void 0 : ref1.legacyProduct;
    }
    return (ref = lineItems.find((lineItem)=>lineItem.type === type
    )) === null || ref === void 0 ? void 0 : ref.legacyProduct;
};

export { getLegacyProductByType };
//# sourceMappingURL=get-legacy-product-by-type.js.map
